import React, { FC } from 'react';
import styled from 'styled-components';
import { Button, ModalContent, ModalHeader, ModalTitle, Text } from 'components';
import { theme, toRem } from 'design';
import { IEmployee, IEmployerSite, IPOSProvider, ISiteIntegration } from 'types';
import { formatIntegrationName } from 'utils';
import { ActionText, ContentFooter, Layout, ResultsWrapper, StyledSubtitle, Wrapper } from '../styles';
import EmployeeInfo from './EmployeeInfo';
import EmployeeList from './EmployeeList';

interface ISuggestedMatchProps {
  dataCy: string;
  integration: ISiteIntegration;
  provider: IPOSProvider;
  site: IEmployerSite;
  employees: IEmployee[];
  selectedEmployee: IEmployee;
  onSetSelectedEmployee(employee: IEmployee): void;
  onClose(): void;
  onContinue(): void;
  onInvite(): void;
  onSearch(): void;
}

const StyledContentFooter = styled(ContentFooter)`
  align-items: start;
  border-top: ${toRem(1)} solid ${theme.color.neutral[100]};
  padding-top: ${toRem(theme.space.lg)};
`;

const SuggestedMatch: FC<ISuggestedMatchProps> = ({ provider, integration, site, employees, selectedEmployee, onSetSelectedEmployee, onContinue, onClose, onInvite, onSearch, dataCy }: ISuggestedMatchProps) => (
  <Layout isActive onClose={onClose} data-cy={`${dataCy}-suggested-match`} maxWidth={540}>
    <ModalHeader>
      <ModalTitle data-cy="modal-title">Connect {formatIntegrationName(integration)} Employee To Kickfin</ModalTitle>
      <StyledSubtitle data-cy="modal-subtitle">Create a connection between employees on your POS to Kickfin users.</StyledSubtitle>
    </ModalHeader>
    <ModalContent>
      <Wrapper>
        <EmployeeInfo name={provider.name} type={provider.type} employeeId={provider.customerEmployeeId} dataCy={dataCy} />
        <Wrapper>
          <ResultsWrapper>
            <Text fontWeight="semibold" size="small">
              Suggested Matches ({employees.length})
            </Text>
            <EmployeeList site={site} employees={employees} onSelect={onSetSelectedEmployee} selectedEmployee={selectedEmployee} integration={integration} dataCy={dataCy} />
          </ResultsWrapper>
          <Button appearance="primary" label="Continue" disabled={!selectedEmployee} onClick={onContinue} />
          <StyledContentFooter>
            <Text fontWeight="semibold" size="small">
              Not finding the correct Kickfin user?
            </Text>
            <ActionText size="small" onClick={onSearch}>
              Search your existing user list
            </ActionText>
            <ActionText size="small" onClick={onInvite}>
              Invite a new user
            </ActionText>
          </StyledContentFooter>
        </Wrapper>
      </Wrapper>
    </ModalContent>
  </Layout>
);

export default SuggestedMatch;
